@if (displayedText(); as displayedText) {
<div>
	<span libWordBreak [innerHtml]="displayedText | textToHtml"> </span>
	@if (showMoreButton() || showLessButton()) {
	<span
		>&nbsp;@if (showMoreButton()) {
		<a (click)="shoreMore()">More</a>
		}@if (showLessButton()) {
		<a (click)="showLess()">Less</a>
		}
	</span>
	}
</div>
}
